<template>
  <section v-if="value" class="atom-image" :style="value.style">
    <div class="edit" v-if="edit">
      <el-button-group>
        <div>
          <el-button @click="openInputMedia = true"><i class="material-icons">insert_photo</i></el-button>
        </div>
        <div class="edit-atom">
          <el-radio-group v-model="value.style.textAlign" size="mini">
            <el-radio-button label="left"><i class="material-icons">format_align_left</i></el-radio-button>
            <el-radio-button label="center"><i class="material-icons">format_align_center</i></el-radio-button>
            <el-radio-button label="right"><i class="material-icons">format_align_right</i></el-radio-button>
          </el-radio-group>
          <div>
            <el-button @click="$emit('meta')"><i class="material-icons">extension</i></el-button>
          </div>
        </div>
      </el-button-group>
    </div>

    <div class="image" v-if="value.source">
      <input-media v-model="value.source" :open="openInputMedia"/>
    </div>
  </section>
</template>

<script>

import InputMedia from '@/components/forms/InputMedia.vue';

export default {
  name: 'AtomImage',
  components: {
    InputMedia,
  },
  props: ['value', 'edit'],
  watch: {
    value: 'init',
  },
  created() {
    this.init();
  },
  data() {
    return {
      openInputMedia: false,
    };
  },
  methods: {
    init() {
      this.$set(this.value, 'source', this.value.source || {});
      this.$set(this.value, 'style', this.value.style || {});
      this.$set(this.value, 'meta', this.value.meta || {});
      this.$set(this.value.style, 'textAlign', this.value.style.textAlign || 'center');
    },
  },
};
</script>

<style lang="sass">
.atom-image
  display: block
  padding: 1rem
  min-height: 80px
  .input-media
    padding: 0
    background: white
    span
      display: block
    .image
      max-width: 100%
      object-fit: contain

</style>
